import { RemotePersonGetById } from 'data/usecases';
import { GetByIdPersonUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetByIdPerson = (): GetByIdPersonUseCaseInterface =>
  new RemotePersonGetById(makeApiUrlPerson(), makeAxiosHttpClient());
